var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperApprovedDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 83,
    viewBox: "0 0 64 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_51892)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3908 65.9264H15.0996L15.3095 44.9902H23.6007L23.3908 65.9264Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5646 48.4689C23.5646 46.7079 24.0255 45.5054 25.1841 44.1493C25.1841 44.1493 28.8821 40.5874 29.9749 39.2792C30.7774 38.3199 31.0429 37.0356 31.0429 36.1302L31.0799 32.7738C31.0799 31.296 32.0554 30.1951 33.5803 30.1951H33.6564C36.0929 30.1114 38.3113 33.0191 38.4965 35.9487C38.7599 40.1327 36.912 42.492 35.7184 44.0336C35.4221 44.4185 35.7102 44.9609 36.2041 44.9609H45.2443C47.0017 44.9609 48.6974 46.341 48.79 48.0441C48.8868 49.827 47.5018 51.3188 45.7197 51.4644C45.625 51.4723 45.7176 51.4763 45.7259 51.4763C47.082 51.4883 48.3126 52.4376 48.4484 53.7458C48.5987 55.1937 47.4874 56.4262 46.0531 56.5319C45.9851 56.5379 46.0263 56.5418 46.088 56.5458C47.226 56.6256 48.2447 57.4034 48.4278 58.5002C48.6583 59.8763 47.6623 61.0769 46.3329 61.2364C46.2341 61.2484 46.1992 61.2943 46.2815 61.3182C47.3125 61.6373 48.0451 62.6065 47.9669 63.7293C47.8825 64.9438 46.6416 65.923 45.3863 65.923H23.3896L23.5646 48.4689Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1588 79.8824C62.1588 80.7814 61.43 81.5102 60.531 81.5102H3.36314C2.46413 81.5102 1.73535 80.7814 1.73535 79.8824V20.3663C1.73535 19.985 1.86923 19.6157 2.11364 19.323L16.3604 2.26028C16.6696 1.88988 17.1273 1.67578 17.6099 1.67578H60.531C61.43 1.67578 62.1588 2.40457 62.1588 3.30357V79.8824Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4554 2.24023V18.5409C17.4554 19.4436 16.7208 20.1739 15.8181 20.1686L2.32812 20.0901",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_51892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 82.963,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperApprovedDesktop);
export default __webpack_public_path__ + "static/media/PaperApprovedDesktop.4a2a01ddedcdfb60ae254ed8ff54338d.svg";
export { ForwardRef as ReactComponent };